// @flow
import React from 'react';
import injectSheet from 'react-jss';
import {
  TEMPLATE_VALUE_TYPES as TYPES,
  S3_ASSET_BROWSER_DEFAULT_OPTIONS
} from 'shared/constants';
import S3AssetBrowser from '~/pages/components/S3AssetBrowser';
import TextInput from '~/app/components/TextInput';
import CalendarPicker from './CalendarPicker';
import DateTimePicker from './DateTimePicker';
import Checkbox from './Checkbox';
import Dropdown from './Dropdown';
import { S, DARK } from '~/app/ui/tokens';

type Schema = {
  type: string,
  label: string,
  key: string,
  options: any[],
  children: ?Schema[]
}

type Props = {
  schema: Schema,
  classes: Object,
  value: any,
  onChange: Function,
}

function EditTemplateProp({
  classes: c, schema, value, onChange
}: Props) {
  const arrayItems = schema.type === TYPES.ARRAY && (
    value && value.map((item, i) => (
      <div className={c.container2} key={i}>
        {schema.children && schema.children.map(child => (
          <EditTemplateProp
            root={false}
            key={child.key}
            schema={child}
            classes={c}
            onChange={(key, newVal) => {
              const res = value.slice();

              res[i] = {
                ...res[i],
                [key]: newVal
              };
              onChange(schema.key, res);
            }}
            value={item[child.key]}
          />
        ))}
        <div
          className={c.removeItem}
        >
          <div
            className={c.removeBtn}
            onClick={() => {
              const res = value.slice();

              res.splice(i, 1);
              onChange(schema.key, res);
            }}
          >
            <i className="material-icons">remove_circle_outline</i>
            Remove item
          </div>

        </div>
      </div>
    ))
  );
  const addItem = schema.type === TYPES.ARRAY && (
    <div
      className={c.addItem}
      onClick={() => {
        const res = value ? value.slice() : [];
        const obj = {};

        if (schema.children) {
          schema.children.forEach((child) => {
            // TODO: This implementation assumes a text input.
            obj[child.key] = '';
          });
        }
        res.push(obj);
        onChange(schema.key, res);
      }}
    >
      <i className="material-icons">add_circle</i>
      Add item
    </div>
  );

  return (
    <div className={c.container}>
      <div className={c.label}>{schema.label}</div>
      <div className={( schema.type === TYPES.ARRAY ) ? c.container2 : c.containerThin}>
        {arrayItems}
        {addItem}
        {schema.type === TYPES.ENUM &&
          <Dropdown
            value={value}
            options={schema.options}
            onChange={newVal => onChange(schema.key, newVal)}
          />
        }
        {schema.type === TYPES.STRING &&
          <TextInput
            key={schema.key}
            type="text"
            classname={c.textInput}
            value={value}
            onChange={e => onChange(schema.key, e.target.value)}
          />
        }
        {schema.type === TYPES.DATE &&
          <CalendarPicker
            value={value}
            onChange={newVal => onChange(schema.key, newVal)}
          />
        }
        {schema.type === TYPES.DATETIME &&
          <DateTimePicker
            value={value}
            onChange={newVal => onChange(schema.key, newVal)}
          />
        }
        {schema.type === TYPES.BOOLEAN &&
          <Checkbox
            value={value}
            onChange={newVal => onChange(schema.key, newVal)}
          />
        }
        {schema.type === TYPES.S3_ASSET_URL &&
          <S3AssetBrowser
            value={value}
            className={c.commonInput}
            onChange={newValue => onChange(schema.key, newValue)}
            options={{ ...S3_ASSET_BROWSER_DEFAULT_OPTIONS, ...schema.options }}
          />
        }
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexGrow: '1',
    flexDirection: 'column'
  },
  label: {
    fontWeight: '300',
    fontSize: '16px',
    paddingRight: '10px',
    paddingBottom: '16px',
    color: 'hsl(0, 0%, 40%)',
    padding: '0 0px 5px 3px',
    [DARK]: { color: S.muted }
  },
  addItem: {
    display: 'flex',
    fontSize: '14px',
    color: 'hsl(0, 0%, 40%)',
    [DARK]: { color: S.muted },
    alignItems: 'center',
    fontWeight: '300',
    marginBottom: '100px',
    marginTop: '20px',
    cursor: 'pointer',
    alignSelf: 'flex-end',
    '& > .material-icons': {
      fontSize: '14px',
      marginRight: '5px'
    }
  },
  removeItem: {
    fontSize: '14px',
    color: 'hsl(0, 100%, 40%)',
    [DARK]: { color: S.red },
    fontWeight: '300',
    marginBottom: '20px',
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column'
  },
  removeBtn: {
    width: '122px',
    cursor: 'pointer',
    display: 'flex',
    alignSelf: 'flex-end',
    alignItems: 'center',
    '& > .material-icons': {
      fontSize: '14px',
      marginRight: '5px'
    }
  },
  container2: {
    boxSizing: 'border-box',
    border: '1px solid hsl(0, 0%, 90%)',
    padding: '10px 10px',
    margin: '10px',
    borderRadius: '5px',
    [DARK]: { borderColor: S.line }
  },
  containerThin: {
    padding: '0px',
    margin: '0px',
  },
  commonInput: {
    marginTop: '0px',
    paddingLeft: '20px',
    fontSize: '12px',
    fontWeight: '400',
    color: 'hsl(0, 0%, 40%)',
    [DARK]: { color: S.muted }
  },
};

export default injectSheet(styles)(EditTemplateProp);
